module.exports = __webpack_public_path__ + "static/media/paint_anim.ecf21c50.gif";